<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="6000"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-layout mt-5>
      <v-flex xs12>
        <div :class="paginatedItems.length === 5 ? 'approvesettlements_box' : 'approvesettlements_box_empty'">
          <v-card-text>
            <v-layout>
              <v-flex xs3>
                <span class="accent--text" style="font-size: 14px; font-weight:700;">{{title}} </span>
              </v-flex>
              <v-spacer>
              </v-spacer>
              <v-flex xs3>
                <v-text-field label="Search" v-model="search">
                </v-text-field>
              </v-flex>
            </v-layout>
            <!--    <h5 class="accent&#45;&#45;text" style="font-size: 12px; font-weight:700">Loan Requests </h5>-->
            <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Member No</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Mobile No</th>
                <th scope="col">Organisaction Name</th>
                <th scope="col">Date Created</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <!--          <th scope="col">Actions</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in paginatedItems" v-bind:key="item.id">
                <td> {{ item.id }} </td>
                <td> {{ item.farmer.memberNumber }} </td>
                <td>{{ item.farmer.firstName }}</td>
                <td>{{ item.farmer.lastName }}</td>
                <td>{{ item.farmer.mobileNumber }}</td>
                <td>{{ item.grower.organisationName }}</td>
                <td>{{ item.dateCreated}}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.disburseStatus.description }}</td>
              </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              :total-visible="7"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
export default {
  name: 'loansummary',
  data: function () {
    return {
      message: '',
      snackbar: false,
      snackbarColor: '',
      loading: false,
      search: '',
      results: [],
      totalResults: 0,
      paginatedItems: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 10,
      page: 1,
      currentPage: 0

    }
  },
  computed: {
    title () {
      return 'Loan Requests for ' + ' ' + this.paginatedItems[0].grower.organisationName
    }
  },
  mounted () {
    this.loadData(this.currentPage)
  },
  watch: {
    results: function () {
      // this.numberOfLinks = Math.ceil(this.results.length / this.numberOfItemsPerPage)
      this.paginatedItems = this.results
      // this.paginationMethod(this.results, 1, this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedItems = this.loadData(val - 1)
      // this.paginationMethod(this.results, val, this.numberOfItemsPerPage)
    }
  },
  methods: {
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    loadData (page) {
      const url = config.serverURI + `/disbursement/all/${this.$route.params.orgisationCode}` + '?page=' + page + '&size=' + this.numberOfItemsPerPage + '&paginate=Y'
      axios.get(url)
        .then(response => {
          console.log('Responzee',response.data.data)
          this.results = response.data.data
          this.numberOfLinks = response.data.page.totalPages
          this.numberOfItemsPerPage = response.data.page.size
          this.currentPage = response.data.page.number
        })
        .catch(error => {
          console.log('error', error.response)
        })
      return this.results
    }
  }
}

</script>
<style scoped>
.mytable .v-table tbody tr:not(:last-child) {
  border-bottom: none;
}
.approvesettlements_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.approvesettlements_box:after, .approvesettlements_box:before {
  right: 100%;
  top: 80%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.approvesettlements_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}
.approvesettlements_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.table  tbody  tr >  td.actions {
  font-size: 10px !important;
  color: #733D29 !important;
  text-align:center;
  vertical-align: middle;
  padding-top: 0px;
  height: 10px;
}

div,.table {
  overflow-x: auto;
}

td {
  max-width: 200px; /* Set a maximum width for cells */
  overflow: hidden;
  text-overflow: ellipsis; /* Show ellipsis (...) for text overflow */
  white-space: nowrap; /* Prevent text from wrapping */

}

</style>
